<template>
  <v-container fluid class="leaderboard-container py-2 px-2">
        <h2 class="text-h4 text-center neon-glow">Score: {{ score }}</h2>
        
        <v-row justify="center">
          <v-col xl="4" lg="6" md="8" sm="8">
            <h3 class="text-h8 neon-glow mb-1 mt-2">Leaderboard - {{ capitalizedDeviceType }}</h3>
            
            <v-row class="font-weight-bold mb-2 text-white" no-gutters>
              <v-col cols="2">#</v-col>
              <v-col cols="6">Name</v-col>
              <v-col cols="4" class="text-right">Score</v-col>
            </v-row>

            <v-divider class="mb-2"></v-divider>

            <div v-for="(entry, index) in leaderboard" :key="index">
              <v-row
                :class="['py-1', localPlayerName === entry.name ? 'highlight-row' : 'text-white']"
                align="center"
                no-gutters
              >
                <v-col cols="2">{{ index + 1 }}</v-col>
                <v-col cols="6">{{ truncateName(entry.name) }}</v-col>
                <v-col cols="4" class="text-right">{{ entry.score }}</v-col>
              </v-row>
            </div>

          </v-col>
        </v-row>
        

        <v-container max-width="300px" v-if ="!scoreSubmitted" class="score-submit-box py-4 px-3">
          <v-row dense     
            class="d-flex align-center"
            :class="$vuetify.breakpoint.mdAndDown ? 'flex-column' : 'flex-row'">
            <v-col 
              cols="12" 
              xl="6"
              lg="6"
              md="6"
              sm="6">
              <v-text-field
                v-model="localPlayerName"
                placeholder="Enter Name Here"
                outlined
                dense
                hide-details
                class="neon-input"
              />
            </v-col>
            <v-col 
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6">
              <v-btn
                class="mt-0 neon-submit-btn"
                height = 3em
                block
                :disabled="scoreSubmitted"
                @click="submitScore"
                outlined
              >
                Leave My Name On Board!
              </v-btn>
            </v-col>
          </v-row>
        </v-container>


        <v-btn 
          class="neon-button mt-6 mb-1"
          height = 2.5em
          outlined
          @click="$emit('restart')">Replay
        </v-btn>

  </v-container>
</template>
  
<script>
export default {
  props: {
    score: Number,
    gameId: String,
    playerName: String,
    scoreSubmitted: Boolean
  },
  data() {
    return {
      leaderboard: [],
      localPlayerName: this.playerName,
      deviceType: '' // 'desktop' or 'mobile'
    };
  },
  mounted() {
    this.deviceType = this.getDeviceType();
    this.fetchLeaderboard();
  },

  methods: {
    getDeviceType() {
      const ua = navigator.userAgent;
      if (/Mobi|Android|iPhone|iPad|Tablet/i.test(ua)) {
        return 'mobile';
      }
      return 'desktop';
    },
    fetchLeaderboard() {
      const type = this.deviceType === 'desktop' ? 'desktop' : 'mobile';
      fetch(`https://xiziwang.me/api/get_leaderboard.php?game_id=${this.gameId}_${type}`)
        .then(res => res.json())
        .then(data => {
          this.leaderboard = data;
        });
    },
    submitScore() {
      if (!this.localPlayerName || this.scoreSubmitted) return;
      if (!/^[a-zA-Z0-9 _-]{1,50}$/.test(this.localPlayerName)) {
        alert("Name must be 1–50 characters, and can only include letters, numbers, space, _ or -");
        return;
      }

      this.$emit('update:scoreSubmitted', true);

      const data = new URLSearchParams();
      const type = this.deviceType === 'desktop' ? 'desktop' : 'mobile';
      data.append("game_id", `${this.gameId}_${type}`);
      data.append("name", this.localPlayerName);
      data.append("score", this.score);

      fetch("https://xiziwang.me/api/submit_score.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data
      })
        .then(res => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          return res.json();
        })
        .then(() => this.fetchLeaderboard())
        .catch(err => {
          console.error("Score submission failed:", err);
        });
    },

    truncateName(name) {
      return name.length > 15 ? name.slice(0, 15) + '...' : name;
    },
  },

  computed: {
    capitalizedDeviceType() {
      return this.deviceType.charAt(0).toUpperCase() + this.deviceType.slice(1);
    }
  }

};
</script>

<style scoped>
.neon-glow {
  color: #cffffa;
  text-shadow: 0 0 6px #00ffe7, 0 0 12px #00ffe7;
}

.leaderboard-container {
  color: #fff;
}

.highlight-row {
  background-color: rgba(0, 255, 255, 0.1);
  color: #cffffa;
  text-shadow: 0 0 6px #00ffe7, 0 0 12px #00ffe7;
  font-weight: bold;
}




.neon-button {
  color: #1e1e2f;
  font-size: 20px;
  font-weight: bold;
  padding: 16px 40px;
  background-color: #cffffa;
  border: 2px solid #00ffe7;
  border-radius: 8px;
  text-shadow: 0 0 8px #00ffe7;
  box-shadow: 0 0 8px #00ffe7, 0 0 24px #00ffe7;
  transition: all 0.3s ease;
}

.neon-button:hover {
  background-color: #8cfff4;
  color: #1e1e2f;
  box-shadow: 0 0 20px #00ffe7, 0 0 40px #00ffe7;
}



::v-deep(.neon-input .v-input__control) {
  background-color: rgba(255, 255, 255, 0.05);
  border: 2px solid #00ffe7;
  color: #cffffa;
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.4);
}

::v-deep(.neon-input input) {
  color: #cffffa;
  text-shadow: 0 0 8px #00ffe7;
}

::v-deep(.neon-input .v-label) {
  color: #010302;
  font-weight: bold;
}


.neon-submit-btn {
  color: #cffffa;
  font-weight: bold;
  border: 2px solid #00ffe7;
  background-color: #1e1e2f;
  box-shadow: 0 0 10px #00ffe7;
  text-shadow: 0 0 4px #00ffe7;
}

.neon-submit-btn:hover {
  background-color: #8cfff4;
  color: #1e1e2f;
  box-shadow: 0 0 20px #00ffe7;
}

</style>